<template>
    <div class="mail-wrap" light fluid >
            <v-layout row nowrap class="mail-layout">
                <v-flex class="mail-folders">
                    <v-list dense class="pt-0">
                    <div class="write-letter d-flex justify-center" v-if="!disabledSend">
                        <v-btn class="d-flex justify-center" large color="info" @click="writeLetter=true">Написать письмо
                            <v-icon class="create-icon">create</v-icon>
                        </v-btn>
                    </div>
                        <MailFolder v-for="(folder, index) in folders" @select="onSelectFolder" :key="index" :mails="mails" :folder="folder" @move-mail="moveMail($event)" @action="onAction($event)" :select-id="selectedFolderId"/>
                        <MailFolder v-if="!disabledSend" @select="onSelectFolder" :mails="mails" :folder="{id: 0, title: 'Корзина', icon: 'delete', noedit: true}" @move-mail="moveMail($event)" @action="onAction($event)" :select-id="selectedFolderId"/>
                    </v-list>

                    <div class="interface-mail-folders">
                    </div>
                </v-flex>

                <v-flex xs9 class="mail-table">
                    <v-data-table
                            :headers="headers"
                            :items="mailsFromFolder"
                            :no-data-text="emptyText"
                            hide-actions>

                        <template slot="items" slot-scope="props">
                            <tr draggable="true" @dragstart="onDragStart($event, props.item)" @click="onSelectMail(props.item.id)">
                                <td>{{ props.item.from }}</td>
                                <td>{{ props.item.theme }}</td>
                                <td class="justify-center layout px-0">
                                    <v-btn v-if="!disabledDelete" icon class="mx-0" @click="deleteItem(props.item)">
                                        <v-icon class="delete-icon" color="pink">delete</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <WriteLetter @send-mail="onSendMail($event)" :is-open="writeLetter" />
                    <MailMail v-if="selectMail" :id="selectMail.id" :from="selectMail.from" :theme="selectMail.theme" :message="selectMail.message" :time="selectMail.time"/>
                </v-flex>
            </v-layout>
    </div>
</template>

<script>
    import MailFolder from './folder'
    import MailMail from './mail-main'
    import WriteLetter from './WriteLetter'
    import randomId from '@/utils/randomId.js'
    import VueScrollTo from 'vue-scrollto'

    export default {
        name: 'interface-mail',
        components: {
            MailFolder,
            MailMail,
            WriteLetter
        },
        props: {
            disabledSend: Boolean,
            disabledDelete: Boolean,
            folders: {
                type: Array,
                default: () => []
            },
            mails: {
                type: Array,
                default: () => []
            }
        },
        data: () => ({
            selectedMailId: null,
            selectedFolderId: 1,
            writeLetter: false,
            headers: [
                {
                    text: 'От кого',
                    align: 'left',
                    sortable: false,
                    value: 'from'
                },
                {
                    text: 'Тема',
                    align: 'left',
                    sortable: false,
                    value: 'theme'
                },
                { text: '', value: 'name', sortable: false }
            ],
            emptyText: 'Пусто'
        }),
        computed: {
            selectMail () {
                if (this.selectedMailId) {
                    let index = this.mails.findIndex(item => item.id === this.selectedMailId)
                    if (index > -1) {
                        return this.mails[index]
                    }
                }
                /* eslint-disable */
                this.selectedMailId = null
            },
            mailsFromFolder () {
                if (typeof this.selectedFolderId === 'number') {
                    return this.mails.filter(item => item.folder === this.selectedFolderId)
                } else {
                    return this.mails
                }
            }
        },
        methods: {
            onSelectMail (id) {
                this.selectedMailId = id

                this.$nextTick(() => {
                    VueScrollTo.scrollTo(document.querySelector('.interface-mail-mail'), 1000, {
                        container: '.mail-table',
                        offset: -50
                    })
                })
            },
            onSelectFolder (id) {
                this.selectedMailId = null
                this.selectedFolderId = id
            },
            deleteItem (item) {
                let currentMail = this.mails.filter(mail => mail.id == item.id)[0]
                currentMail.folder = this.mainFolderNames['trash']
            },
            onAction(data) {
                this.$emit('action', Object.assign({}, data, {action: 'create'}))
            },
            onSendMail(data) {
                if (data.shouldSend) {
                    this.mails.push({
                        id: randomId(),
                        folder: this.mainFolderNames.send,
                        theme: data.subject,
                        to: data.to,
                        from: 'Me',
                        message: data.content
                    })
                }
                this.writeLetter = false
            },
            moveMail(event) {
                let {dstFolder, mailId} = event
                let curMail = this.mails.filter(mail => mail.id == mailId)[0]
                curMail.folder = dstFolder
                this.$emit('sort')
            },
            onDragStart(event, data) {
                event.dataTransfer.setData(JSON.stringify({mailId:data.id}), data.id);
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .mail-wrap {
        height 100%
    }
    .mail-layout {
        height 100%
    }
    .mail-folders {
        background-color #fff
        border-right 1px solid rgba(0,0,0,0.12)
    }
    .mail-table {
        overflow auto
        min-width 500px

        .delete-icon {
            opacity 0
        }
        tr {
            &:hover {
                .delete-icon {
                    opacity 1
                }
            }
        }
    }
    .create-icon {
        margin-left 10px
    }
    .write-letter {
        max-width 300px
        margin 0 auto
    }
</style>

